import React, { useEffect, useState } from "react";
import Routes from "./routes/Routes";
import "./assets/scss/main.scss";
import { GlobalContext } from "./context";


function App() {
  
  return (
    <>
      <GlobalContext.Provider value={""}>
        <div className={`App`}>
          <Routes />
        </div>
      </GlobalContext.Provider>
    </>
  );
}

export default App;
